import classnames from 'classnames';
import * as queryString from 'query-string';
import { useSelector } from 'react-redux';
import Image from '../../components/image/Image';
import { Subtitle } from '../../components/typography/Heading';
import styles from './showImageModal.module.less';
import { ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { useProject } from '../project-hooks/useProject';

const TvaImagesModalContent = ({ onBack, trackingProperties }) => {
    const project = useProject();

    const DownloadBox = ({ projectId, title, text, background, params }) => {
        const baseUrl = useSelector((state) => state.baseURL);
        const query = queryString.stringify({ ...params, name: title });

        const link = `${baseUrl}/api/public/project/${projectId}/tva-image?${query}`;

        const download = () => {
            window.open(link);
            trackEvent('project', `tva-image-download-modal`, { ...trackingProperties });
            onBack();
        };

        return (
            <div className={styles.downloadBox} onClick={download} role={'button'}>
                <Subtitle>{title}</Subtitle>
                <div className={styles.badge}>
                    <Image src={project?.img_url} className={styles.projectImage} />
                    <div className={classnames(background, styles.badgeContainer)}>
                        <Image src={`campaign/tva2023/${text}`} className={styles.badgeImage} />
                        <div className={styles.badgeText}>
                            <span>Gå hit for å støtte min bøsse</span>
                            <strong>spleis.no/{projectId}</strong>
                        </div>
                    </div>
                </div>
                <span className={styles.downloadLink}>Last ned</span>
            </div>
        );
    };

    return (
        <ModalBlock>
            <Heading2 id={'share-modal-title'}>Last ned delingsbilder</Heading2>
            <DownloadBox
                title={'Digital bøssebærer - kvadratisk'}
                background={styles.spleisBlueBackground}
                text={'stott_tva_hvit.svg'}
                params={{
                    backgroundColor: '#005aa4',
                    color: '#FFFFFF',
                    text: 'zgv2rabjchmagwylqkap.svg',
                    projectHeight: 624,
                    height: 1200,
                    width: 1200,
                }}
                projectId={project.id}
            />
            <DownloadBox
                title={'Digital bøssebærer - kvadratisk hvit'}
                background={styles.whiteBackground}
                text={'stott_tva_bla.svg'}
                params={{
                    backgroundColor: '#FFFFFF',
                    color: '#002776',
                    text: 'mejxsejn3xe35osy96bo.svg',
                    projectHeight: 624,
                    height: 1200,
                    width: 1200,
                }}
                projectId={project.id}
            />
            <DownloadBox
                title={'Digital bøssebærer - stående format'}
                background={styles.spleisBlueBackground}
                text={'stott_tva_hvit.svg'}
                params={{
                    backgroundColor: '#005aa4',
                    color: '#FFFFFF',
                    text: 'zgv2rabjchmagwylqkap.svg',
                    projectHeight: 561,
                    height: 1920,
                    width: 1080,
                }}
                projectId={project.id}
            />
            {onBack && <SecondaryButton onClick={onBack}>Tilbake</SecondaryButton>}
        </ModalBlock>
    );
};

export default TvaImagesModalContent;
